import chat, { PATH as CHAT } from './Chat'

export default { chat }
export const PATH = { CHAT }
